/**
 * Slots publicitarios (tabla `ads.slot`) y recordatorio de tamaños para Admin / Partner.
 * Medidas alineadas con layout real: hero 242px alto, laterales 200px ancho (SDD-13 / appendix layout).
 */

export const AD_SLOT_OPTIONS = [
  {
    value: 'hero_marketplace',
    label: 'Hero marketplace',
    sizeHint:
      'Ancho útil ~1400 px (contenedor centrado), alto visible 242 px. Recomendado: imagen 1400×400 px o vídeo MP4 horizontal 16:9; se aplica recorte cover. Sin campaña activa: archivo en `public/banner_hero.{mp4|webm|png|jpg|webp|gif}` (primer formato encontrado).',
    promptExtra:
      'Uso: carrusel principal del home del marketplace. El clic abre el enlace de la campaña en nueva pestaña.',
  },
  {
    value: 'hero_comunidad_destacados',
    label: 'Comunidad · slide destacados',
    sizeHint:
      'Bloque central Comunidad (~ancho columna central, máx. ~1280 px). Zona imagen/vídeo: 140 px de alto, ancho 100 %, object-fit contain (no recorta como cover). Recomendado: imagen 1200×400 px o vídeo MP4 horizontal; debajo va título y texto en la UI (no hace falta duplicar mucho texto en la imagen).',
    promptExtra:
      'Uso: carrusel «Destacado» arriba del listado de Comunidad (sustituye eventos marcados como destacados si hay campañas activas). Clic → enlace de campaña.',
  },
  {
    value: 'lateral_mercado_subastas',
    label: 'Lateral mercado / subastas',
    sizeHint:
      'Columna derecha 200 px de ancho, alto variable (sticky, ~320–600 px visibles). Recomendado: 200×600 px (vertical) o 400×1200 px; imagen, GIF o vídeo MP4 en bucle. Fallback: `public/banner_lateral_mercado.{mp4|webm|png|…}` (o `fallback_lateral_mercado.*`).',
    promptExtra: 'Uso: columna derecha en Mercado y en Subastas (mismo slot).',
  },
  {
    value: 'lateral_comunidad',
    label: 'Lateral comunidad',
    sizeHint:
      'Igual que lateral mercado: 200 px de ancho, bloque vertical sticky. Recomendado: 200×600 px o 400×1200 px. Fallback: `public/fallback_lateral_comunidad.{mp4|webm|png|…}`.',
    promptExtra: 'Uso: columna derecha en la página Comunidad.',
  },
  {
    value: 'lateral_noticias',
    label: 'Lateral noticias',
    sizeHint:
      'Columna derecha 200 px (listado noticias, contenedor ~1300 px). Recomendado: 200×600 px o 400×1200 px. Fallback: `public/banner_lateral_noticias.*` o `fallback_lateral_noticias.*`.',
    promptExtra: 'Uso: columna derecha en Noticias.',
  },
  {
    value: 'noticia_patrocinada',
    label: 'Noticia patrocinada (card en grid)',
    sizeHint:
      'Tarjeta en grid (mín. ~320 px de ancho). Recomendado: 640×360 px (16:9) o 800×450 px; imagen o GIF llamativo.',
    promptExtra: 'Uso: una card extra en el grid de noticias cuando hay campaña activa.',
  },
];

export const AD_MEDIA_TYPE_OPTIONS = [
  { value: 'image', label: 'Imagen (JPG, PNG, WebP)' },
  { value: 'gif', label: 'GIF animado' },
  { value: 'video', label: 'Vídeo (MP4)' },
];

/** @param {string} slot */
export function getAdSlotSizeHint(slot) {
  const s = AD_SLOT_OPTIONS.find(o => o.value === String(slot || '').trim());
  return s?.sizeHint ?? '';
}

/** @param {string} slot */
export function getAdSlotLabel(slot) {
  const s = AD_SLOT_OPTIONS.find(o => o.value === String(slot || '').trim());
  return s?.label ?? slot;
}

/**
 * Texto para pegar en un prompt de IA (tamaños + contexto DreamVinyl).
 * @param {string} slotValue
 * @returns {string}
 */
export function buildAdSlotPromptSnippet(slotValue) {
  const slot = AD_SLOT_OPTIONS.find(o => o.value === String(slotValue || '').trim());
  if (!slot) return '';

  return [
    'Contexto: creatividad visual para DreamVinyl (marketplace de vinilos, comunidad musical y eventos; estética oscura elegante, acentos dorados #c8a84b, sensación premium y actual).',
    '',
    `Ubicación en la web: ${slot.label}.`,
    '',
    'Debe cumplir estas especificaciones técnicas:',
    slot.sizeHint,
    slot.promptExtra ? `\n${slot.promptExtra}` : '',
    '',
    'Indicaciones de estilo DreamVinyl:',
    '- Temática musical / vinilos / cultura de coleccionismo.',
    '- Composición clara; evitar textos pequeños en los bordes (en móvil se recorta o se reduce).',
    '- Si lleva texto incrustado, que sea breve, legible y en español.',
    '- Sin logos de terceros no autorizados.',
  ]
    .filter(Boolean)
    .join('\n');
}
